module.exports = __webpack_public_path__ + "static/ymca@2x-b58afb8e73c99a1433ba2f1fee5be653.png";